import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon, Button } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';

import * as commonVar from 'libs/commonVar';

import { CtAttachReg, CtExamAttachDelete } from 'containers';
import { ExamAttachCopyModal, ExamAttachEditModal } from 'components';

import classNames from 'classnames/bind';
import styles from './ExamAttachTableMenu.css';

const cx = classNames.bind(styles);

class ExamAttachTableMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      editModal: false,
      copyModal: false
    };
  }

  mountDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  mountCopyModal = () => {
    this.setState({ copyModal: !this.state.copyModal });
  };

  mountEditModal = () => {
    this.setState({ editModal: !this.state.editModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleteModal, copyModal, editModal } = this.state;
    const { isAuth, templateInfo } = this.props;
    const { mountDeleteModal, mountCopyModal, mountEditModal } = this;

    const { attachInfoNo, isEnable } = templateInfo;

    return (
      <div className={'inline-conf-area'}>
        {/* {(isAuth === 2 || attachInfoNo) && (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'ExamAttachInTableMenu_1', defaultMessage: '첨부파일 수정' }))}
            placement="bottom">
            <Icon color="grey" className={cx('icon-edit')} name="edit" link onClick={mountEditModal} />
          </Tooltip>
        )}
        {editModal && (
          <ExamAttachEditModal isAuth={isAuth} templateInfo={templateInfo} mountEditModal={mountEditModal} />
        )} */}

        {((commonVar.isGs !== 1 && isAuth === 2) || attachInfoNo) &&
          (isEnable === 1 ? (
            <Tooltip
              title={defineMessages(formatMessage({ id: 'ExamAttachInTableMenu_3', defaultMessage: '첨부파일 복제' }))}
              placement="bottom">
              <Icon color="grey" className="icon-remove" name="copy" link onClick={mountCopyModal} />
            </Tooltip>
          ) : null)}
        {((commonVar.isGs !== 1 && isAuth === 2) || attachInfoNo) &&
          copyModal && (
            <ExamAttachCopyModal isAuth={isAuth} templateInfo={templateInfo} handleOnToggleModal={mountCopyModal} />
          )}

        {(commonVar.isGs !== 1 && isAuth === 2 || attachInfoNo) && isEnable === 1 && (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'ExamAttachInTableMenu_1', defaultMessage: '첨부파일 수정' }))}
            placement="bottom">
            <Icon color="grey" className={cx('icon-edit')} name="edit" link onClick={mountEditModal} />
          </Tooltip>
        )}
        {((commonVar.isGs !== 1 && isAuth === 2) || attachInfoNo) &&
          editModal && (<ExamAttachEditModal isAuth={isAuth} templateInfo={templateInfo} handleOnToggleModal={mountEditModal} />
          )}

        {((commonVar.isGs !== 1 && isAuth === 2) || attachInfoNo) &&
          (isEnable === 1 ? (
            <Tooltip
              title={defineMessages(formatMessage({ id: 'ExamAttachInTableMenu_2', defaultMessage: '첨부파일 삭제' }))}
              placement="bottom">
              <Icon color="grey" className="icon-remove" name="remove circle" link onClick={mountDeleteModal} />
            </Tooltip>
          ) : null)}
        {((commonVar.isGs !== 1 && isAuth === 2) || attachInfoNo) &&
          deleteModal && (
            <CtExamAttachDelete isAuth={isAuth} templateInfo={templateInfo} mountDeleteModal={mountDeleteModal} />
          )}
      </div>
    );
  }
}

ExamAttachTableMenu.propTypes = {
  //
};
ExamAttachTableMenu.defaultProps = {
  //
};

export default injectIntl(ExamAttachTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachTableMenu.js